<template>
  <section
    id="cover"
    class="te-bg-webdevelopment-advanced-image relative flex flex-col items-center justify-center bg-cover bg-center px-4 text-center text-white"
    style="height: 500px"
  >
    <h1 class="co-display-5 mb-4 flex items-center font-bold drop-shadow">
      <FontAwesomeIcon
        :icon="faLaptopCode"
        class="fa-fw mr-3 mt-2 hidden size-9 md:inline-block"
      />
      Web制作実践コース
    </h1>
    <h2 class="co-display-10 mb-2 drop-shadow">
      現役エンジニアの徹底サポートでWeb制作のスキルアップに取り組もう
    </h2>
    <div
      class="co-container-xs co-display-14 mb-6 drop-shadow"
      aria-hidden="true"
    >
      <span class="te-cover-lead">
        実際のフロントエンドの案件を想定した模擬案件に取り
        <span
          class="hidden"
          :class="{ '!inline': isActive }"
        >組み、短期間でWeb制作のコーディング案件を担当できるスキルが身につく講座。スクールでは4種の模擬案件やポートフォリオサイト制作に取り組みます。通過率10%を突破した現役エンジニアから学べるオンラインのプログラミングスクール。1人では続かない方のためのパーソナルメンターがつくプログラミングブートキャンプ。専属のパーソナルメンターがマンツーマンでサポート。副業の案件紹介もあります。</span>
      </span>
      <span @click="isActive = !isActive">
        <FontAwesomeIcon
          v-if="isActive"
          :icon="faChevronUp"
          class="fa-fw ml-2 inline size-3"
        />
        <FontAwesomeIcon
          v-else-if="!isActive"
          :icon="faChevronDown"
          class="fa-fw ml-2 inline size-3"
        />
      </span>
    </div>
    <TeCourseCoverTimeSpan
      :begins-at="beginsAt"
      :closes-at="closesAt"
    />
    <div class="alert mb-4 block w-auto rounded border-[#ffeeba] bg-[#fff3cd] p-2 text-center text-[#856404]">
      お申し込みを停止しております。 再開の際には改めてご案内いたします。
    </div>

    <!-- Adobeバッジ -->
    <TeCommonBadgeAdobe />
  </section>
</template>

<script lang="ts">
import TeCourseCoverTimeSpan from '~/components/Te/TeCourse/TeCourseCoverTimeSpan.vue'
import TeCommonBadgeAdobe from '~/components/Te/TeCommon/Badge/Adobe/TeCommonBadgeAdobe.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faLaptopCode } from '@awesome.me/kit-65d95819ce/icons/classic/regular'
import { faChevronUp, faChevronDown } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

interface Props {
  beginsAt: Date
  closesAt: Date
}

const options = {
  async setup() {
    return {
      faLaptopCode,
      faChevronUp,
      faChevronDown,
    }
  },
  props: {
    beginsAt: {
      type: Date,
      default: null,
    },
    closesAt: {
      type: Date,
      default: null,
    },
  },
  data() {
    return {
      isActive: false,
    }
  },
  components: {
    TeCourseCoverTimeSpan,
    TeCommonBadgeAdobe,
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
.te-bg-webdevelopment-advanced-image {
  background-image: linear-gradient(
      to top,
      rgba(132, 91, 163, 0.75),
      rgba(132, 91, 163, 0.75)
    ),
    url('~/assets/images/Te/TeCourse/WebdevelopmentAdvanced/Cover/webdevelopment-advanced.jpg');
}
</style>
